import { InputHTMLAttributes, useState } from "react";
import { twMerge } from "tailwind-merge";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  showPassword?: boolean;
  validation?: string;
  showValidation?: any;
}

export function Input({ ...rest }: InputProps) {
    const [dirt, setDirt] = useState(false);

  return (
    <div className="relative w-full">
      <input
        {...rest}
        onBlur={()=> setDirt(true)}
        className={twMerge(
          "tw-w-full tw-justify-center tw-items-start tw-px-4 tw-py-2.5 tw-mt-3 tw-text-justify tw-whitespace-nowrap tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-zinc-500 tw-text-zinc-500 tw-max-md:tw-pr-5 tw-max-md:tw-mt-10 tw-max-md:tw-max-w-full",
          dirt && rest.showValidation && rest.showValidation() ? " tw-border-red-500  placeholder:tw-text-red-500 focus:tw-border-zinc-500 focus:placeholder:tw-text-zinc-500" : "",
          rest.className
        )}
      />
      <span
        className={twMerge(
          "absolute -bottom-5 left-0 text-base w-full",
          dirt && rest.showValidation && rest.showValidation() ? "tw-text-red-500 focus:tw-text-zinc-500 " : "tw-text-transparent"
        )}
      >
        {rest.validation}
      </span>
    </div>
  );
}
